module.exports = __webpack_public_path__ + "static/media/download.2b24cf76.svg";